import { render, staticRenderFns } from "./CustomDeliveryDetailsForm.vue?vue&type=template&id=9e38b02c"
import script from "./CustomDeliveryDetailsForm.vue?vue&type=script&lang=js"
export * from "./CustomDeliveryDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports